import React from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import AppContainer from "../../AppContainer";

export default function PrivacyPolicies() {
  return (
    <AppContainer>
      <div className="container-home">
        <div className="header center grey-text text-darken-3">
          <h2>AVISO DE PRIVACIDAD</h2>
          <b>DASHPORT, S.A.P.I. de C.V. </b> a través de su representante
          Eduardo Madrid Alvarez de Lugo, con domicilio en el predio marcado con
          el número 295 de la Calle robles con cruzamientos entre las calles almendros y limonarias
          de la Colonia La Rejoyada en la ciudad de Mérida Yucatán, el cual es el
          responsable del uso y protección de sus datos personales, a si como
          para atender sus solicitudes respecto a los mismos, y al respecto le
          informa lo siguiente:
          <p>
            Los datos personales que recabamos de usted, los utilizaremos para
            las siguientes finalidades que son necesarias para el servicio que
            solicita a fin de poder brindarle este de manera eficiente:
          </p>
          <p>
            Solicitar su autorización de enviarle información vía correo
            electrónico sobre el o los eventos deportivos en los cuales se
            encuentre inscrito. De manera adicional, utilizaremos su información
            personal para las siguientes finalidades que no son necesarias para
            el servicio solicitado, pero que nos permiten y facilitan brindarle
            una mejor atención: . Mantenerlo informado sobre los cambios del o
            los eventos en los que se encuentre inscrito. Identificar a cada
            usuario a fin de que el servicio pueda ser personalizado atendiendo
            a sus intereses con respecto al servicio que se le proporciona
            Proveerle información acerca de eventos, talleres, o programas que
            puedan ser de su interés de acuerdo al giro de nuestro negocio. En
            caso de que no desee que sus datos sean tratados con las finalidades
            de manera adicional, puede manifestar su negativa al margen de este
            mismo escrito, enviando un correo electrónico a info@dashport.run,
            con la leyenda “NO DESEO QUE MIS DATOS PERSONALES SEAN TRATADOS DE
            MANERA ADICIONAL AL SERVICIO QUE ME SERA PROPORCIONADO”, acompañado
            de su firma autógrafa.
          </p>
          <p>
            Para llevar a cabo las finalidades descritas en el presente aviso de
            privacidad, utilizaremos los siguientes datos personales de
            identificación y contacto:
          </p>
          <p>Fecha de Nacimiento Domicilio Correo Electrónico Teléfono</p>
          <p>
            Le informamos que sus datos personales no serán divulgados por
            ningún medio de comunicación, que permita que otros usuarios tengan
            acceso a sus datos personales.
          </p>
          <p>
            Siendo indispensable contar con su información actualizada, para el
            o los eventos en los que se encuentre inscrito, puede tener acceso
            para la rectificación, cancelación u oposición de sus datos
            personales previamente proporcionados, para fines específicos, en
            caso de rectificación deberá indicar las modificaciones a realizarse
            aportando la documentación necesaria que sustente su petición. Estos
            derechos se conocen como derechos ARCO; enviando su solicitud por
            medio del siguiente correo electrónico con el título “RECTIFICACION
            DE DATOS PERSONALES:
          </p>
          <p>info@dashport.run</p>
          <p>
            Acompañando la siguiente documentación que facilite su localización:
          </p>
          <p>
            Nombre del titular y domicilio para comunicar la respuesta a su
            solicitud. Los Documentos que acrediten la identidad o, en su caso,
            la representación legal el titular. La descripción clara y precisa
            de los datos personales respecto de los que se busca ejercer los
            derechos mencionados. Cualquier otro elemento o documento que
            facilite la localización de los datos personales. Le comunicamos que
            sus solicitudes serán atendidas a la brevedad posible, en un plazo
            máximo de veinte días hábiles, contados desde la fecha en que se
            recibió la solicitud de acceso, rectificación, cancelación u
            oposición, haciéndole llegar la respuesta correspondiente por medio
            de la dirección de correo electrónico que previamente nos
            proporcione, procediendo a realizar la misma en caso de ser
            procedente en un plazo de quince días naturales siguientes a la
            comunicación de su respuesta.
          </p>
          <p>
            Asimismo usted tiene derecho a revocar su consentimiento para el
            tratamiento de sus datos personales, siguiendo el procedimiento
            antes descrito, sin embargo es importante, para sus debido
            conocimiento que no en todos los casos podremos atender su solicitud
            de revocación, por situaciones de índole legal o administrativo que
            nos requiera seguir tratando sus datos personales, la revocación
            implicara que no le podamos seguir brindando el servicio solicitado
            inicialmente.
          </p>
          <p>
            Le informamos que sus datos personales para brindarle mayor
            seguridad por ningún motivo serán trasferidos a terceros.
          </p>
          <p>
            En caso de que el presente aviso de privacidad, implique algún
            cambio por disposiciones legales, administrativas o con fines de
            mejora continua, nos comprometemos a mantenerlo informado, por medio
            de envío de correo electrónico y/o notificaciones por escrito, en la
            dirección que previamente nos proporcione, con la finalidad de
            poderles ofrecer un servicio eficaz.
          </p>
          <p>
            Los datos personales que nos proporciona, permanecerá en resguardo
            del responsable por un periodo de tres años a partir del día
            siguiente en el que nos otorgue su autorización ello, con fundamento
            en el articulo 10 de la Ley Federal de Protección de Datos
            Personales en Posesión de los Particulares.
          </p>
          <p>
            Otorgo mi consentimiento para que mis datos personales sean tratados
            conforme a lo señalado en el presente aviso de privacidad.
          </p>
        </div>



        <section>
          <h1>Términos y Condiciones de Uso – Dashport</h1>
          <p>
            <strong>Última actualización:</strong> Octubre 2025
          </p>
          <p>
            <strong>Razón social:</strong> Dashport SAPI de CV
          </p>
          <p>
            <strong>RFC:</strong> DAS171012PC8
          </p>
          <p>
            <strong>Sitio web:</strong>{" "}
            <a
              href="https://www.dashport.run"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.dashport.run
            </a>
          </p>
          <p>
            <strong>Correo de contacto:</strong>{" "}
            <a href="mailto:info@dashport.run">info@dashport.run</a>
          </p>
          <p>
            <strong>Teléfono:</strong>{" "}
            +52 220 574 71 08
          </p>

          <h2>1. Aceptación de los términos</h2>
          <p>
            Al utilizar el sitio web <strong>Dashport.run</strong> o cualquiera de
            sus servicios (como el registro e inscripción a eventos deportivos), el
            usuario (“Atleta”, “Usuario” o “Participante”) acepta los presentes{" "}
            <strong>Términos y Condiciones de Uso</strong>, así como nuestra{" "}
            <strong>Política de Devoluciones</strong> y <strong>Aviso de Privacidad</strong>. Si
            no estás de acuerdo con alguno de estos términos, te recomendamos no
            continuar con el uso de la plataforma.
          </p>

          <h2>2. Qué es Dashport</h2>
          <p>
            <strong>Dashport</strong> es una plataforma tecnológica propiedad de{" "}
            <strong>Dashport SAPI de CV</strong>, que permite a organizadores de
            eventos deportivos administrar inscripciones, cronometraje y resultados,
            entre otros servicios.
          </p>
          <p>
            Cuando realizas un registro o pago en Dashport, actuamos únicamente como{" "}
            <strong>intermediarios tecnológicos y de cobro</strong> entre tú y el{" "}
            <strong>organizador del evento</strong>. Esto significa que los{" "}
            <strong>fondos recibidos a través de Dashport pertenecen al organizador</strong>{" "}
            del evento y no a Dashport.
          </p>

          <h2>3. Uso del sitio</h2>
          <ul>
            <li>
              Proporcionar información veraz, completa y actualizada al momento del
              registro.
            </li>
            <li>
              Utilizar el sitio únicamente con fines legítimos relacionados con la
              participación en eventos deportivos.
            </li>
            <li>
              No intentar dañar, modificar o copiar el software, base de datos o
              contenidos de Dashport.
            </li>
          </ul>
          <p>
            Dashport se reserva el derecho de suspender o cancelar cuentas en caso
            de detectar uso indebido o fraudulento.
          </p>

          <h2>4. Inscripciones y pagos</h2>
          <p>
            Los pagos de inscripciones se procesan a través de la pasarela{" "}
            <strong>Openpay</strong> y/o <strong>Conekta</strong> , por lo que la información de tarjetas y
            transacciones se maneja bajo sus propios sistemas de seguridad.
          </p>
          <p>
            Una vez realizado el pago, recibirás la confirmación de tu registro por
            correo electrónico o dentro del panel del evento. El monto pagado
            corresponde al costo establecido por el organizador del evento e
            incluye, en su caso, las comisiones por procesamiento y servicio.
          </p>

          <h2>5. Responsabilidad del organizador</h2>
          <p>
            Dashport no organiza directamente los eventos deportivos publicados en
            su plataforma. Cada evento es responsabilidad del organizador, quien
            define:
          </p>
          <ul>
            <li>Fechas, horarios, rutas, categorías y premios.</li>
            <li>Políticas de cambios, cancelaciones y devoluciones.</li>
            <li>
              Cumplimiento de medidas de seguridad y permisos correspondientes.
            </li>
          </ul>
          <p>
            Dashport únicamente provee la infraestructura tecnológica para facilitar
            el registro y pago.
          </p>

          <h2>6. Propiedad intelectual</h2>
          <p>
            Todo el contenido del sitio web, incluyendo el diseño, software,
            logotipos, imágenes, textos y bases de datos, es propiedad exclusiva de{" "}
            <strong>Dashport SAPI de CV</strong> y está protegido por las leyes
            mexicanas de propiedad intelectual.
          </p>
          <p>
            El usuario no podrá copiar, modificar ni reutilizar ninguna parte de la
            plataforma sin autorización escrita de Dashport.
          </p>

          <h2>7. Privacidad y protección de datos</h2>
          <p>
            Dashport recopila únicamente la información necesaria para procesar tu
            registro y participación en el evento. Estos datos se comparten{" "}
            <strong>solo con el organizador</strong> del evento correspondiente y{" "}
            <strong>no se utilizan con fines comerciales o publicitarios</strong>.
          </p>
          <p>
            Puedes consultar el <strong>Aviso de Privacidad</strong> completo al
            final de este documento.
          </p>

          <h2>8. Limitación de responsabilidad</h2>
          <p>Dashport no se hace responsable por:</p>
          <ul>
            <li>Cancelaciones, cambios o alteraciones realizadas por los organizadores.</li>
            <li>Lesiones, accidentes o daños ocurridos durante los eventos deportivos.</li>
            <li>Fallas en servicios externos (como pasarelas de pago, proveedores de internet o terceros).</li>
          </ul>
          <p>
            No obstante, Dashport procurará siempre apoyar en la comunicación entre
            el usuario y el organizador en caso de incidencias.
          </p>

          <h2>9. Jurisdicción</h2>
          <p>
            Estos términos se rigen por las leyes de los{" "}
            <strong>Estados Unidos Mexicanos</strong>. Cualquier controversia
            relacionada con el uso de la plataforma será resuelta ante los
            tribunales competentes de <strong>Mérida, Yucatán, México</strong>.
          </p>


          <hr style={{ margin: "40px 0" }} />

          <h1>Política de Devoluciones y Reembolsos</h1>
          <p>
            <strong>Última actualización:</strong> Octubre 2025
          </p>
          <p>
            En Dashport entendemos que pueden existir imprevistos, por eso te
            explicamos de manera clara cómo funciona el proceso de devoluciones o
            reembolsos.
          </p>

          <h2>1. Quién gestiona las devoluciones</h2>
          <p>
            Las devoluciones son responsabilidad del{" "}
            <strong>organizador del evento</strong>. Dashport no define políticas de
            reembolso, pero puede apoyar en la gestión del proceso cuando el pago se
            realizó a través de nuestra plataforma.
          </p>

          <h2>2. Procedimiento</h2>
          <p>Si deseas solicitar una devolución:</p>
          <ol>
            <li>
              Contacta directamente al organizador del evento y explica el motivo de
              tu solicitud.
            </li>
            <li>
              Una vez que el organizador apruebe el reembolso, Dashport procesará la
              devolución correspondiente (total o parcial) mediante el mismo método
              de pago original, utilizando <strong>Conekta</strong> como pasarela.
            </li>
            <li>
              El tiempo de reembolso puede variar según el banco o método de pago
              utilizado (entre 5 y 15 días hábiles, en promedio).
            </li>
          </ol>

          <h2>3. Casos en que puede aplicarse una devolución</h2>
          <p>Las devoluciones pueden aplicarse en los siguientes casos:</p>
          <ul>
            <li>Cancelación oficial del evento por parte del organizador.</li>
            <li>Error de duplicidad en el pago.</li>
            <li>Problemas técnicos comprobables en la transacción.</li>
          </ul>

          <p>No se aplicarán devoluciones cuando:</p>
          <ul>
            <li>El atleta no se presente al evento.</li>
            <li>Existan errores en datos personales proporcionados por el usuario.</li>
            <li>
              El evento haya modificado su fecha o sede por causas ajenas al
              organizador (clima, permisos, seguridad, etc.), salvo que el
              organizador lo autorice.
            </li>
          </ul>

          <h2>4. Tipo de reembolso</h2>
          <p>El reembolso puede ser:</p>
          <ul>
            <li>
              <strong>Total:</strong> cuando el evento se cancela completamente o el
              pago se duplica.
            </li>
            <li>
              <strong>Parcial:</strong> cuando el organizador autoriza un reembolso
              descontando costos de inscripción, comisiones de pago u otros gastos
              operativos.
            </li>
          </ul>

          <h2>5. Contacto</h2>
          <p>Para cualquier duda o seguimiento sobre tu devolución, puedes escribirnos a:</p>
          <p>
            <strong>Correo:</strong>{" "}
            <a href="mailto:info@dashport.run">info@dashport.run</a>
            <br />
            Indica el nombre del evento, tu número de registro y el comprobante de
            pago.
          </p>
        </section>



        <div className="row center"></div>
      </div>
    </AppContainer>
  );
}
